export default __webpack_public_path__ + "static/media/enbek-migration-logo.a640bd39.svg";